<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-contactus");

    let email= "";
    let message="";
    let sending=false;
    $: disabled = !(email.length > 0 && message.length > 0) || sending;
    
     export function open () {
        jQuery('#GPContactUs').modal({});
        jQuery('#GPContactUs').on('hidden.bs.modal', () => this.$destroy())

        //manage focus
        jQuery('#GPContactUs').on('show.bs.modal',GP.storeFocus);
        jQuery('#GPContactUs').on('shown.bs.modal',function (){jQuery('#GPContactUs #contactEmail').focus();});
        jQuery('#GPContactUs').on('hidden.bs.modal',GP.restoreFocus);

        //trap focus
        jQuery('#GPContactUs .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
        jQuery('#contactSubmit').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});
    }

    function contactUsSend() {
        if (!disabled) {
            sending = true;
            jQuery.ajax({
                type: "POST",
                data: {
                    email: email,
                    "ticket[subject]": trans("Feedback about") + " " + GPSettings.appDescription,
                    "ticket[message]": message + GPSettings.extraDebugInfo()
                },
                url: GPSettings.servicesAddr + "/contact",
                success: contactUsSent
            });
        }
        return false;
    }
    
    function contactUsSent() {
        jQuery('#GPContactUs').modal('hide');
    }

</script>

<div class="modal fade GPModal" tabindex="-1" id="GPContactUs">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{trans("Fill in the form to contact us")}</h4>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label for="contactEmail">{trans("Your email")}</label>
                    <input type="email" class="form-control" id="contactEmail" placeholder="Email" bind:value="{email}">
                </div>
                <div class="form-group">
                    <label for="contactMessage">{trans("Message")}</label>
                    <textarea class="form-control" id="contactMessage" rows="8" bind:value="{message}"></textarea>
                </div>
                <button id="contactSubmit" class="btn btn-default {disabled ? 'disabled' : ''}" on:click="{contactUsSend}">{trans("Submit")} {#if sending}<i class="button-waiting fa fa-spinner fa-spin" style="display: inline-block"></i>{/if}</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->     